module.exports = __webpack_public_path__ + "img/comision1.094a143c.png";